import _styled, { default as _styled2, default as _styled3 } from "styled-components";
var _templateObject, _templateObject2;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React, { forwardRef } from 'react';
import * as styles from "./LoadingSpinner.styles";
export var LOADING_SPINNER_WRAPPER = 'loading_spinner__wrapper';

/** @deprecated Ribbons consumers should not rely on a Ribbons component's internal implementation details */
export var LOADING_SPINNER_CLASS = 'loading-spinner';
export var LoadingSpinner = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var className = _ref.className,
    _ref$colorMode = _ref.colorMode,
    colorMode = _ref$colorMode === void 0 ? 'dark' : _ref$colorMode,
    message = _ref.message,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'medium' : _ref$size;
  return /*#__PURE__*/React.createElement(_StyledDiv, {
    className: className,
    "data-testid": LOADING_SPINNER_WRAPPER,
    ref: ref,
    $_css: styles.loadingWrapper
  }, /*#__PURE__*/React.createElement(_StyledDiv2, {
    $_css2: [styles.spinner, styles.spinnerColor[colorMode], styles.spinnerSize[size]]
  }), message && /*#__PURE__*/React.createElement(_StyledP, {
    $_css3: styles.loadingMessage
  }, message));
});
var _StyledDiv = _styled("div")(_templateObject || (_templateObject = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css;
});
var _StyledDiv2 = _styled2("div")(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css2;
});
var _StyledP = /*#__PURE__*/_styled3("p").withConfig({
  displayName: "LoadingSpinner___StyledP",
  componentId: "sc-wko4kg-0"
})(["", ""], function (p) {
  return p.$_css3;
});